export enum OrderTypeEnum {
  GIFT_CARD_ORDER = 1,
  STORE_ORDER = 2,
  CUBACEL_ORDER = 3,
}
